/**
 * @generated SignedSource<<c0e9f85c37df4eef66654f43647aeec7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RenderContentBlock_block$data = {
  readonly content: string;
  readonly id: string;
  readonly " $fragmentType": "RenderContentBlock_block";
};
export type RenderContentBlock_block$key = {
  readonly " $data"?: RenderContentBlock_block$data;
  readonly " $fragmentSpreads": FragmentRefs<"RenderContentBlock_block">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RenderContentBlock_block",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    }
  ],
  "type": "ContentBlock",
  "abstractKey": null
};

(node as any).hash = "da9e39aa224e53f3a3c92d9ca6988cfc";

export default node;
